import { render, staticRenderFns } from "./SnackbarComponent.vue?vue&type=template&id=20193ffa&scoped=true"
import script from "./SnackbarComponent.js?vue&type=script&lang=js&external"
export * from "./SnackbarComponent.js?vue&type=script&lang=js&external"
import style0 from "./SnackbarComponent.vue?vue&type=style&index=0&id=20193ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20193ffa",
  null
  
)

export default component.exports